import css from 'styled-jsx/css';

const styles = css.global`#emprestimo-garantia-condicoes{
    padding: 32px 0;
    display: flex;
    flex-direction: column;
    gap: 32px;
    overflow: hidden;
    background: #FBFBFB;
}

#emprestimo-garantia-condicoes .condicoes-contain {
    border-radius: 4px;
    border: 1px solid #C00;
    position: relative;
    padding: 0 8px;
    padding-bottom: 34px;
}

#emprestimo-garantia-condicoes .condicoes-contain-img {
    position: absolute;
    height: 167px; 
    top: 41px;
    left: 50%;
    transform: translate(-50%, 0);
}

#emprestimo-garantia-condicoes .condicoes-contain-titulo {
    margin-top: 241px;
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 34px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
}

#emprestimo-garantia-condicoes .condicoes-contain-subtitulo {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; 
}

#emprestimo-garantia-condicoes .condicoes-contain-cards {
    display: flex;
    flex-direction: column;
    gap: 47px;
    margin-top: 31px;
}

#emprestimo-garantia-condicoes .cards-condicao {
    display: flex;
    flex-direction: column;
    gap: 24px;
}
#emprestimo-garantia-condicoes .card-condicao {
    display: flex;
    gap: 16px;
    align-items: center;
}

#emprestimo-garantia-condicoes .card-condicao .condicao-textos {
    display: flex;
    flex-direction: column;
}

#emprestimo-garantia-condicoes .card-condicao .condicao-textos-titulo {
    margin: 0;
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
} 

#emprestimo-garantia-condicoes .card-condicao .condicao-textos-descricao {
    color: #999;
    font-family: "SantanderMicroText";
    font-size: 14px;
    font-style: normal;
    font-weight: 200;
    line-height: 22px;
}


@media (min-width: 992px) {
    #emprestimo-garantia-condicoes {
        padding: 40px 0;
    }
    #emprestimo-garantia-condicoes .ctn-home-24 {
        max-width: 1279px;
    }

    #emprestimo-garantia-condicoes .condicoes-contain {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
        padding: 32px 0 34px;
        gap: 75px;
        height: 285px;
    }

    #emprestimo-garantia-condicoes .condicoes-contain-img {
        position: relative;
        left: 110px;
        margin-left: -320px;
        top: -7px;
        height: 273px;
        transform: none
    }

    #emprestimo-garantia-condicoes .condicoes-contain-conteudo {
        width: 50%;
    }

    #emprestimo-garantia-condicoes .condicoes-contain-titulo {
        margin-top: 0;
    }

}`;

export default styles;